import React from "react";
import { Formik } from "formik";
import { TextField, withStyles, Button, FormHelperText, Chip, Typography, FormControl, InputLabel, Select, MenuItem, CircularProgress } from "@material-ui/core";
import * as Yup from "yup";
import Autocomplete from '@material-ui/lab/Autocomplete';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    helperText: {
        marginTop: '4px'
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "120px",
        marginTop: "10px"
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: 'right'
    }

});

const NotificationSettingForm = props => {
    const { classes, formSettings, initialValues, loading, handleSubmit, translations, possibleNotifications, customers } = props;
    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, setFieldValue, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Receivers"
                                value={values.Receivers}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(touched.Receivers && errors.Receivers)}
                                placeholder={translations['receivers'] || 'Receivers'}
                                label={translations['receivers'] || 'Receivers'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <FormHelperText className={classes.helperText} >{`${translations['split_emails'] || 'Please, split emails with '}";"`}</FormHelperText>

                            <Autocomplete
                                name={'Type'}
                                multiple
                                id="TypeMultiSelect"
                                options={possibleNotifications || []}
                                getOptionSelected={(option, value) => option.label === value.label}
                                getOptionLabel={(option) => option.label}
                                filterSelectedOptions
                                value={values.Type}
                                onChange={(_, value) => setFieldValue('Type', value)}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" fullWidth={true} label={translations['notifications_select'] || 'Please select notification for given email'} />
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip label={option.label} {...getTagProps({ index })} />
                                    ))
                                }
                            />
                            <FormControl className={classes.formControl} margin={'dense'}>
                                <InputLabel shrink>{translations['leave_empty_notification_text'] || "Please select customer only if its customer specific"}</InputLabel>
                                <Select name="CustomerID" margin={'dense'} value={values.CustomerID} onChange={handleChange}>
                                    {(customers ? [{ CustomerID: null, Name: '[System]' }, ...customers] : []).map(option => (
                                        <MenuItem key={option.CustomerID} value={option.CustomerID}>
                                            {option.Name}
                                        </MenuItem>
                                    ))}
                                </Select>

                            </FormControl>
                            <div className={classes.buttons}>
                                {formSettings.ButtonCancel ? (
                                    <Button
                                        className={classes.cancel}
                                        variant="contained"
                                        onClick={formSettings.ButtonCancel.handleCancel}
                                        disabled={loading}

                                    >
                                        {formSettings.ButtonCancel.Title}
                                    </Button>
                                ) : null
                                }
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting || loading || !(isValid && dirty)}
                                    >
                                        {loading ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(NotificationSettingForm);
